import React from 'react';
import { Link } from 'react-router-dom';

const DatenschutzPage = () => {
    // (Stile wie bei ImpressumPage)
    return (
        <div style={{ padding: '20px', color: '#aaa', maxWidth: '600px', margin: '0 auto' }}>
            <Link to="/" style={{ color: '#007BFF', textDecoration: 'none', fontSize: '1.2em' }}>&larr; Back to Map</Link>
            <h1>Privacy Policy</h1>
            <p>We take your privacy seriously. Here's what we collect and why:</p>
            <ul>
                <li><strong>Nickname & Selfie:</strong> Your chosen nickname and uploaded photo are visible to other users within the context of an event you create or join. This is essential for the app's function.</li>
                <li><strong>Favorite Vibe:</strong> We store your favorite sport/activity to personalize your map view.</li>
                <li><strong>Cookies:</strong> We use a single, essential HTTP-only cookie to keep you "logged in" on your device without a password.</li>
                <li><strong>Event Data:</strong> Information you provide when creating an event (title, time, location) is stored and displayed to other users.</li>
            </ul>
            <p><strong>What we DON'T collect:</strong> We do not ask for, store, or process your email address, real name, phone number, or any other personal data.</p>
            <p>All event data is automatically deleted after the event has finished. We do not keep a history.</p>
        </div>
    );
};
export default DatenschutzPage;
